<template>
  <div class="by-election">
    <div class="by-election-content">
      <div class="rank-list-1">
        <div class="ranking-item ranking-1">
          <div class="avatar-box" @click="toPlayerDetail(rankList[1])">
            <div class="avatar-b">
              <img
                class="avatar"
                :src="rankList[1] ? rankList[1].avatarUrl : ''"
                alt=""
              />
            </div>

            <img class="avatar-border" src="./images/no2.png" alt="" />
          </div>
          <span class="user-name">{{
            rankList[1] ? rankList[1].nickname : ''
          }}</span>
          <button
            class="btn-voice"
            :class="{
              active: rankList[1] ? rankList[1].voiceUrl : false
            }"
            @click="playAudio(rankList[1])"
          >
            語音介紹
          </button>
        </div>
        <div class="ranking-item ranking-2">
          <div class="avatar-box" @click="toPlayerDetail(rankList[0])">
            <div class="avatar-b">
              <img
                class="avatar"
                :src="rankList[0] ? rankList[0].avatarUrl : ''"
                alt=""
              />
            </div>
            <img class="avatar-border" src="./images/no1.png" alt="" />
          </div>
          <span class="user-name">{{
            rankList[0] ? rankList[0].nickname : ''
          }}</span>
          <button
            class="btn-voice"
            :class="{
              active: rankList[0] ? rankList[0].voiceUrl : false
            }"
            @click="playAudio(rankList[0])"
          >
            語音介紹
          </button>
        </div>
        <div class="ranking-item ranking-3">
          <div class="avatar-box" @click="toPlayerDetail(rankList[2])">
            <div class="avatar-b">
              <img
                class="avatar"
                :src="rankList[2] ? rankList[2].avatarUrl : ''"
                alt=""
              />
            </div>
            <img class="avatar-border" src="./images/no3.png" alt="" />
          </div>
          <span class="user-name">{{
            rankList[2] ? rankList[2].nickname : ''
          }}</span>
          <button
            class="btn-voice"
            :class="{
              active: rankList[2] ? rankList[2].voiceUrl : false
            }"
            @click="playAudio(rankList[2])"
          >
            語音介紹
          </button>
        </div>
      </div>
      <div class="rank-list-2">
        <div class="rank-item" v-for="index in 7" :key="index">
          <div class="user-info">
            <span class="number">{{ index + 3 }}</span>
            <img
              class="avatar"
              :src="rankList[index + 2].avatarUrl"
              alt=""
              v-if="
                rankList && rankList[index + 2] && rankList[index + 2].avatarUrl
              "
              @click="toPlayerDetail(rankList[index + 2])"
            />
            <img class="avatar" src="./images/empty.png" alt="" v-else />

            <span class="user-name">{{
              rankList[index + 2] ? rankList[index + 2].nickname : ''
            }}</span>
          </div>
          <button
            class="btn-voice"
            :class="{
              active: rankList[index + 2] ? rankList[index + 2].voiceUrl : false
            }"
            @click="playAudio(rankList[index + 2])"
          >
            語音介紹
          </button>
        </div>
      </div>
      <div class="my-rank" v-if="isPlayer && appendInfo.rankNum">
        <div>
          <span> 您当前排名第{{ appendInfo.rankNum }}位 </span>
          <span>
            距离排名上一位陪玩师差距：{{
              appendInfo.NewYearStage1EndDateNeedAmount
            }}收入
          </span>
        </div>
      </div>
      <!-- 预选席 -->
      <div class="pre-selection-seats-box">
        <div class="jewel-title">
          <img class="jewel" src="./images/jewel.png" alt="" />
          <span>預選席</span>
          <img class="jewel" src="./images/jewel.png" alt="" />
        </div>
        <div class="user-box">
          <div
            class="user-item"
            v-for="index in 40"
            :key="index"
            @click="toPlayerDetail(list[index - 1])"
          >
            <img
              class="avatar"
              v-if="list[index - 1] && list[index - 1].avatarUrl"
              :src="list[index - 1].avatarUrl"
              alt=""
            />
            <img class="avatar" src="./images/empty.png" alt="" v-else />
            <span
              class="user-name"
              v-if="list[index - 1] && list[index - 1].nickname"
              >{{ list[index - 1].nickname }}</span
            >
            <span class="user-name" v-else>虚位以待</span>
          </div>
        </div>
      </div>
    </div>
    <div class="rules-box">
      <div class="jewel-title">
        <img class="jewel" src="./images/jewel.png" alt="" />
        <span>補選階段規則</span>
        <img class="jewel" src="./images/jewel.png" alt="" />
      </div>
      <div class="content-title">- 補選時間：2023/1/19 -2023/2/3 23:59:59</div>
      <p class="content">
        -
        活動規則：補選階段全平台陪玩師進行大比拼，根據平台陪玩師在活動期間所完成的訂單實付總金額的大小進行排名，抉擇出40名陪玩師進入「新春盛典初賽階段」【注：2022年獲得過周星榜單第一名的陪玩師直接獲取參賽資格進入top40名單內，剩下名額由其他陪玩師進行順位候補】
      </p>
      <div class="content-title">特殊道具說明：</div>
      <p class="content">
        -
        【應援票】價值99鑽石，但不可購買，只能開啓福袋或購買鑰匙獲得，可作為禮物正常結算給陪玩師；<br />

        - 【應援票】可作為特殊道具在初賽階段為陪玩師積累特殊積分!<br />

        - 盛典獎勵：點擊福袋右側「盛典獎勵說明」處即可查看<br />

        - 福袋獎勵：點擊新春福袋跳轉到「新春福袋」頁面可查看獎勵内容
      </p>
    </div>
    <audio
      ref="audio"
      preload="preload"
      :src="voiceUrl"
      @pause="pauseAudio()"
      @play="startPlayAudio()"
    ></audio>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ByElection',
  props: {
    activityData: {
      typeof: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      voiceUrl: '',
      playStatus: null
    };
  },
  watch: {},
  computed: {
    ...mapGetters([
      'userInfo'
      // 'masterInfo'
    ]),
    list() {
      try {
        return this.activityData.appendInfo.byElection || [];
      } catch (error) {
        return [];
      }
    },
    //獲獎排名
    rankList() {
      try {
        return this.activityData.appendInfo.NewYearStage1EndDate || [];
      } catch (error) {
        return [];
      }
    },
    appendInfo() {
      try {
        return this.activityData.appendInfo || {};
      } catch (error) {
        return {};
      }
    },
    // 是B端用户
    isPlayer() {
      return this.userInfo && this.userInfo.userKind === 'Player';
    }
  },
  methods: {
    // 查看陪玩師詳情
    toPlayerDetail(userInfo) {
      if (userInfo && userInfo.userUuid) {
        this.$router.push({
          path: `/player-detail/${userInfo.userUuid}`
        });
      }
    },
    playAudio(userInfo) {
      console.log('playAudio', this.playStatus);
      if (userInfo && userInfo.voiceUrl) {
        if (this.voiceUrl === userInfo.voiceUrl) {
          if (this.playStatus === 'pause') {
            this.$refs.audio.play();
            return;
          }
          if (this.playStatus === 'play') {
            this.$refs.audio.pause();
            return;
          }
        } else {
          this.voiceUrl = userInfo.voiceUrl;
          setTimeout(() => {
            this.$refs.audio.play();
            this.playStatus = 'play';
          }, 10);
        }
      }
    },
    startPlayAudio() {
      this.playStatus = 'play';
      console.log('startPlayAudio');
    },
    pauseAudio() {
      this.playStatus = 'pause';
      console.log('pauseAudio');
    }
  }
};
</script>
<style lang="scss" scoped>
.by-election {
  width: 100%;
  position: relative;
  margin-top: 10.58rem;
  .by-election-content {
    font-size: 1.83rem;
    color: #e9cc95;
    margin-bottom: 11.42rem;
    padding-bottom: 7.92rem;
    // margin-top: 31.5rem;
    width: 100%;
    background: url('./images/by-election-bg.png') no-repeat center top;
    background-size: 100% 100%;
    .btn-voice {
      width: 11.43rem;
      height: 3.71rem;
      background: #fdd13d;
      border: 0.08px solid #ca8633;
      color: #8c3900;
      opacity: 0.6;
      border-radius: 1.46rem;
      &.active {
        opacity: 1;
      }
    }
    .rank-list-1 {
      // height: 459px;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      padding-top: 14.12rem;
      .ranking-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        .avatar-box {
          position: relative;
          margin-bottom: 17px;
          .avatar-b {
            border-radius: 50%;
            overflow: hidden;
          }
          .avatar {
            object-fit: cover;
            max-width: 100%;
          }
          .avatar-border {
            position: absolute;
            width: 100%;
            top: 0;
          }
        }

        &.ranking-1 {
          .avatar-b {
            width: 14.42rem;
            height: 14.42rem;
            margin-top: 4.5rem;
            margin-left: 2.25rem;
          }
          .avatar-box {
            width: 19.25rem;
            height: 20.33rem;
          }
        }
        &.ranking-2 {
          margin-bottom: 15.4rem;
          .avatar-b {
            width: 18.58rem;
            height: 18.58rem;
            margin-top: 5.58rem;
            margin-left: 5.5rem;
          }
          .avatar-box {
            width: 29.58rem;
            height: 26.33rem;
          }
        }
        &.ranking-3 {
          // margin-left: -10px;
          .avatar-b {
            width: 14.42rem;
            height: 14.42rem;
            margin-top: 4.5rem;
            margin-left: 4.35rem;
          }
          .avatar-box {
            width: 22.75rem;
            height: 20.25rem;
          }
        }
        .btn-voice {
          margin-top: 0.92rem;
        }
      }
    }
    .rank-list-2 {
      margin-top: 8.42rem;
      padding: 0 7.33rem;
      .rank-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 86.92rem;
        border-radius: 4rem;
        position: relative;
        margin-bottom: 8.42rem;
        height: 4.25rem;

        background: rgba(215, 245, 10, 0.09);
        .user-info {
          display: flex;
          align-items: center;
        }

        .number {
          display: inline-block;
          width: 7.83rem;
          text-align: center;
          font-size: 1.83rem;
        }
        .avatar {
          width: 11rem;
          height: 11rem;
          border-radius: 50%;
          position: absolute;
          left: 7.83rem;
        }
        .user-name {
          margin-left: 14.83rem;
        }
        .btn-voice {
          margin-right: 1.75rem;
        }
      }
    }
    .my-rank {
      display: flex;
      justify-content: center;
      > div {
        width: 70rem;
        height: 12rem;
        background: #613204;
        border: 1px solid #f8b151;
        border-radius: 10px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        line-height: 4rem;
      }
    }
    .pre-selection-seats-box {
      margin-top: 8rem;
      padding: 0 4.08rem;
      .user-box {
        width: 92.04rem;
        display: flex;
        flex-wrap: wrap;
        .user-item {
          width: 7.55rem;
          margin-right: 1.5rem;
          text-align: center;
          margin-bottom: 3.83rem;
          .avatar {
            width: 100%;
            height: 7.55rem;
            margin-bottom: 1.5rem;
            border-radius: 50%;
          }
          .user-name {
            font-size: 1.67rem;
            // margin-bottom: 35px;
          }
        }
      }
    }

    .jewel-title {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 5.25rem;
      font-size: 2.92rem;
      .jewel {
        width: 1.67rem;
        margin-left: 1.67rem;
        margin-right: 1.67rem;
      }
    }
  }
  .rules-box {
    width: 100%;
    padding: 8.25rem 4.25rem 5.33rem;
    margin-top: 8.25rem;
    // background: url('./images/by-election-rules-bg.png') no-repeat center top;
    // background-size: 100% auto;
    position: relative;
    color: #e9cc95;
    font-size: 1.67rem;
    margin-bottom: 11.42rem;
    border: 1px solid #ad8756;
    .jewel-title {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 2.92rem;
      display: flex;
      align-items: center;
      background-color: #351808;
      .jewel {
        width: 1.67rem;
        margin-left: 1.67rem;
        margin-right: 1.67rem;
      }
    }
    .content-title {
      color: #fdd241;
      padding-bottom: 2.75rem;
      padding-top: 3rem;
    }
    .content {
      // font-size: 18px;
      line-height: 24px;
    }
  }
}
</style>
